interface IconProps {
    width?: number;
    height?: number;
}

export const ClockIcon = ({ width, height }: IconProps) => {
    const w = width ?? 32;
    const h = height ?? 31;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={w}
            height={h}
            viewBox="0 0 32 31"
            fill="none"
        >
            <path
                stroke="#F0730C"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M16 10.333V15.5l4 3.875m8-3.875c0 6.42-5.373 11.625-12 11.625S4 21.92 4 15.5 9.373 3.875 16 3.875 28 9.08 28 15.5Z"
            />
        </svg>
    );
};
